// StandingsTable — league classification with promotion/relegation zones.
// `broadcast` switches to the TV-graphics treatment: angled position chips,
// procedural crests and a gold row for the player club.

import { StandingsRow, SEASON, PLAYER_CLUB_ID } from '@/config/leagueConfig'
import { ClubCrest } from './broadcast'

interface StandingsTableProps {
  standings: StandingsRow[]
  division: number
  broadcast?: boolean
}

export function StandingsTable({ standings, division, broadcast = false }: StandingsTableProps) {
  const table = (
    <table className="data-table">
      <thead>
        <tr>
          <th style={{ width: broadcast ? '2.2rem' : '1.5rem' }}>#</th>
          <th>Club</th>
          <th className="cell-center">PJ</th>
          <th className="cell-center">G</th>
          <th className="cell-center">P</th>
          <th className="cell-num">Pts</th>
        </tr>
      </thead>
      <tbody>
        {standings.map((row, index) => {
          const position = index + 1
          const isPlayer = row.clubId === PLAYER_CLUB_ID
          const promotes = position <= SEASON.promotedCount && division > 1
          const relegates = position > SEASON.clubsPerDivision - SEASON.relegatedCount && division < 4

          return (
            <tr
              key={row.clubId}
              className={isPlayer ? 'row-me' : undefined}
              style={{
                borderLeft: promotes
                  ? '3px solid var(--success)'
                  : relegates ? '3px solid var(--danger)' : '3px solid transparent',
              }}
            >
              <td style={{ color: 'var(--text-secondary)' }}>
                {broadcast ? (
                  <span className={`pos-chip${promotes ? ' promo' : relegates ? ' releg' : ''}`}>
                    {position}
                  </span>
                ) : (
                  position
                )}
              </td>
              <td style={{
                color: isPlayer ? (broadcast ? 'var(--gold)' : 'var(--accent)') : undefined,
                fontWeight: isPlayer && broadcast ? 700 : undefined,
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '140px',
              }}>
                {broadcast ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', verticalAlign: 'middle' }}>
                    <ClubCrest name={row.name} size={18} />
                    {row.name}
                  </span>
                ) : (
                  row.name
                )}
              </td>
              <td className="cell-center">{row.played}</td>
              <td className="cell-center money-positive">{row.won}</td>
              <td className="cell-center money-negative">{row.lost}</td>
              <td className="cell-num" style={{ fontWeight: 600 }}>{row.points}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )

  return broadcast ? <div className="standings-broadcast">{table}</div> : table
}
